export default __webpack_public_path__ + "static/media/IResponsiveSEFullSize.c0cc8733.png";